import PropTypes from "prop-types";
import classNames from "classnames";
import { createPortal } from "react-dom";

const FullModal = ({ isOpen, children }: any) => {
  const modalClass = classNames(
    "fixed z-[999]  inset-0 overflow-y-auto backdrop-filter backdrop-blur-sm ",
    {
      hidden: !isOpen,
      "bg-gray-800 bg-opacity-75": isOpen,
    }
  );

  // Portaled to <body>: an ancestor with backdrop-filter/transform (e.g. the
  // checkout's .co-card) becomes the containing block for position:fixed, which
  // would otherwise trap this overlay inside that card instead of the viewport.
  return createPortal(
    <div className={modalClass} style={{ touchAction: "manipulation" }}>
      <div className="flex items-center justify-center h-full p-0">
        <div
          className="bg-[#ffffff30] h-full rounded-lg w-full "
          // onClick={onClose} -- Uncomment if `onClose` functionality is desired
        >
          <div className=" h-full flex items-center">{children}</div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

FullModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default FullModal;
